import { useAuth } from '../../contexts/AuthContext';
import { useState, useEffect } from 'react';
import { getFileFromS3, putBOQFileToS3 } from '../../utils/utils';
import Header from '../../components/header/Header.jsx';
import { Box, Button, Center, Input, Text, Flex } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/react';
import { MdOutlineArrowUpward, MdChat } from 'react-icons/md';
import { Link } from 'react-router-dom';
import Footer from 'components/footer/Footer';

import QRCode from 'react-qr-code';

function UploadBOQ() {
	const [email, setEmail] = useState('');
	const [secret, setSecret] = useState('');
	const [file, setFile] = useState(null);
	const [uploading, setUploading] = useState(false);
	const [message, setMessage] = useState('');

	const { user, isAuthenticated, isLoading } = useAuth();
	const userEmail = user?.email;

	const handleFileChange = (e) => {
		setFile(e.target.files[0]);
		console.log(e.target.files[0]);
	};

	async function handleUpload() {
		if (!file) {
			setMessage('Please select a file to upload');
			return;
		}
		setUploading(true);
		setMessage(''); // Clear any previous messages
		
		try {
			console.log('Starting BOQ file upload...', {
				fileName: file.name,
				fileSize: file.size,
				fileType: file.type,
				userEmail: user?.email
			});
			
			// Use the BOQ-specific upload function
			const result = await putBOQFileToS3(file);
			
			setMessage(`✅ File uploaded successfully to BOQ bucket!
📁 File name: ${result.fileName}
🪣 Bucket: ${result.bucket}
📊 Size: ${(file.size / 1024 / 1024).toFixed(2)} MB`);
			
		} catch (error) {
			console.error('Upload error:', error);
			setMessage(`❌ Upload failed: ${error.message}`);
		} finally {
			setUploading(false);
		}
	}

	useEffect(() => {
		if (!isAuthenticated && !isLoading) {
			window.location.href = '/';
		}
	}, [isAuthenticated, isLoading]);

	if (isLoading) {
		return <div>Loading...</div>;
	}

	return (
		<>
			<Header />
			{isAuthenticated && (
				<main className='mx-auto min-h-[650px] max-w-screen-lg items-start justify-start p-4 px-4 text-base sm:px-6 lg:px-8'>
					<Box className='mx-auto max-w-4xl rounded-lg bg-blue-900 p-8 text-white shadow-md '>
						<Text className='mb-6 text-center text-xl font-bold'>Upload Bills of Quantities</Text>
						<Center className='min-h-[250px]'>
							<Box className='flex h-full w-full flex-col items-center justify-center max-w-md'>
								<Text userSelect={'none'} className='pb-5 font-bold text-white'>
									Upload BoQ <span className=' inline font-light text-gray-400'>or BIM Model</span>
								</Text>

								<Center>
									<Flex direction='column' align='center' justify='center'>
										<input type='file' accept='.xls,.xlsx' onChange={handleFileChange} className='relative mb-5 h-[30px] w-[300px] cursor-pointer rounded-lg border-2 border-dashed border-gray-400 bg-blue-800 px-5 py-5 pb-20 pt-14 text-center text-white hover:opacity-95 ' />
										{message && <div>{message}</div>}
									</Flex>
								</Center>
							</Box>
						</Center>
						<Center>
							<Button onClick={handleUpload} disabled={uploading} colorScheme='blue' className='mt-4'>
								{uploading ? 'Uploading...' : 'Upload'}
							</Button>
						</Center>
						
						{/* Chat Link Section */}
						<Center className='mt-6'>
							<Flex direction='column' align='center' gap={3}>
								<Text className='text-sm text-gray-300'>
									Need help with your BOQ analysis?
								</Text>
								<Link to='/chat'>
									<Button 
										colorScheme='blue' 
										leftIcon={<MdChat />}
										className='mt-4'
									>
										Start Chat Analysis
									</Button>
								</Link>
							</Flex>
						</Center>
						{/* <Center className='centerDiv' gap={5} pb={10}>
							<Flex className=' qrWrapper relative mt-14 flex flex-col justify-center rounded-[20px] bg-gradient-to-br from-[#868CFF] via-[#432CF3] to-brand-500 p-10 text-center align-middle'>
								<div className='text-white dark:text-gray-200'>Scan using Google mobile app:</div>
								<QRCode size={256} style={{ height: 'auto', maxWidth: '100%', width: '100%' }} value='https://boq-destination-json-bucket.s3.eu-west-2.amazonaws.com/Refurbishment+Works+-+BoQ.json' viewBox={`0 0 256 256`} />
							</Flex>
						</Center> */}
					</Box>

					{/* Write a code to download apk/test.apk file */}
					{/* <Center>
						<Button
							onClick={() => {
								const link = document.createElement('a');
								link.href = 'https://apkdownloadnow.s3.eu-west-2.amazonaws.com/test.apk';
								link.download = 'test.apk';
								link.click();
							}}
							colorScheme='blue'
							className='mt-4'>
							Download APK
						</Button>
					</Center> */}

					{/* Working Functionality below */}
					{/* <div className='w-full rounded-lg bg-gray-100 p-8 shadow-md'>
						<Flex className='download-container'>
							<div>
								<input type='text' placeholder="file owner's email" value={email} onChange={(e) => setEmail(e.target.value)} />
								<input type='text' placeholder='secret-key' value={secret} onChange={(e) => setSecret(e.target.value)} />
							</div>
							<div>
								<button
									onClick={() => {
										getFileFromS3(`${btoa(email)}${secret?.split('-')[0]}.${secret?.split('-')[1]}`);
									}}>
									Download
								</button>
							</div>
						</Flex>
						<div className='upload-container'>
							<input type='text' value={userEmail} disabled={true} />
							<input type='text' placeholder='secret-key' value={secret} onChange={(e) => setSecret(e.target.value)} />
							<div className='mt-10'>
								<h1>Upload File to S3</h1>
								<input type='file' accept='.xls,.xlsx' onChange={handleFileChange} />
								<button onClick={handleUpload} disabled={uploading}>
									{uploading ? 'Uploading...' : 'Upload'}
								</button>

								<div className='relative h-[30px] w-[200px] cursor-pointer rounded-lg border-2 border-dashed border-gray-400 bg-blue-800 px-20 py-20 pb-20 pt-14 text-center text-white hover:opacity-95 '>
									<Icon as={MdOutlineArrowUpward} w={8} h={8} color='' />
									<input type='file' accept='.xls,.xlsx' onChange={handleFileChange} className=' absolute bottom-0 left-0 right-0 top-0 h-full w-full cursor-pointer opacity-0 ' />
								</div>

								{message && <div>{message}</div>}
							</div>
						</div>
					</div> */}
				</main>
			)}
			<Footer />
		</>
	);
}

export default UploadBOQ;
